const state = {
	location:{
		city:null,
		lat:null,
		lng:null,
		adcode:null
	},
	
	
	shop:{
		shopName:'',
		shopAddress:'',
		lonAndLat:''
	}
	
};

const getters = {
  sShop: state => {
    return state.shop;
  },
  sCity: state => {
    return state.location.city;
  },
  sLocation: state => {
    return state.location;
  }
};

const mutations = {
	sSetLocation(state,location){
		state.location = location;
	},
	sSetShopLocation(state,shop){
		state.shop = shop;
	}
};

const actions = {
  
};

export default {
  state,
  getters,
  mutations,
  actions
};

